import { render, staticRenderFns } from "./ReservationContract.vue?vue&type=template&id=a8b012cc&scoped=true&"
import script from "./ReservationContract.vue?vue&type=script&lang=js&"
export * from "./ReservationContract.vue?vue&type=script&lang=js&"
import style0 from "./ReservationContract.vue?vue&type=style&index=0&id=a8b012cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b012cc",
  null
  
)

export default component.exports